<template>
  <el-cascader
    v-if="isShow"
    v-model="value"
    :options="options"
    @change="emitChange"
    style="width: 100%;"
  >
  </el-cascader>
</template>

<script>
export default {
  model: {
    prop: 'collectorChannel',
    event: 'change',
  },
  props: {
    collectors: {
      type: Array,
    },
    collectorChannel: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      value: [...this.collectorChannel],
      isShow: true,
    };
  },
  computed: {
    options() {
      return this.collectors.map((collector) => {
        const { id, sncode, channelConfig } = collector;

        // 通道子选项
        const children = (channelConfig || []).map((config) => {
          const { channelNo, isUsed } = config;
          return {
            label: `${this.$t('project.channel')} ${channelNo}`,
            value: channelNo,
            disabled: isUsed,
          };
        });

        // 采集器选项
        return {
          label: sncode,
          value: id,
          children,
        };
      });
    },
  },
  watch: {
    collectors: {
      handler() {
        this.isShow = false;
        this.$nextTick(() => {
          this.isShow = true;
        });
      },
      deep: true,
    },
    collectorChannel(newVal) {
      this.value = [...newVal];
    },
  },
  methods: {
    emitChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
